import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { round } from '@sama/micro-dash';
import { map } from 'rxjs/operators';
import { truncateToPoint2D } from '../../../../cross-team-shared/misc-utils';
import { mapPoint } from '../../../../shared/misc-utilities/point-utils';
import {
  Point2D,
  PointType,
} from '../../../../team-apis/otterdam/answers/shape-typings';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';

@Component({
  selector: 'h3-coordinates-box',
  templateUrl: './coordinates-box.component.html',
  styleUrls: ['./coordinates-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class CoordinatesBoxComponent {
  @Input() conversionFunction?: (points: Point2D) => PointType;

  store = inject(AbstractSensorContentStore2D);
  protected coordinates$ = this.buildCoordinates$();
  protected textSizeClass$ = this.coordinates$.pipe(
    map((imagePoint) => imagePoint.length),
    map((length) => ({
      'small-font': length > 16 && length <= 20,
      'extra-small-font': length > 20,
    })),
  );

  private buildCoordinates$() {
    return this.store('mouse')('imagePoint').$.pipe(
      map((imagePoint) => {
        if (this.conversionFunction) {
          const convertedPoints = this.conversionFunction(
            truncateToPoint2D(imagePoint),
          );
          return mapPoint(truncateToPoint2D(convertedPoints), (value) =>
            round(value, 2),
          );
        }
        return imagePoint;
      }),
      map((imagePoint) => imagePoint.join(', ')),
    );
  }
}
